import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Box } from "@mui/material";

import pattern from "../../images/Ig_Logos/pattern-logo.png";
import { setDialog } from "../../store/slices/global";

export const NotSubscribedRoute = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(
      () =>
        dispatch(
          setDialog({
            dialog: "onboarding",
            open: true,
            props: { noClose: true },
          })
        ),
      500
    );
  }, []);

  return (
    <Box
      className={"pattern-background"}
      sx={{
        margin: "-8px",
        height: "100vh",
        opacity: ".65",
        width: "100vw",
        backgroundImage: `url(${pattern})`,
      }}
    ></Box>
  );
};
